import { enableProdMode } from '@angular/core';
import posthog from 'posthog-js';
import { bootstrap } from './bootstrap';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.posthog) {
  posthog.init(environment.posthog.key, {
    api_host: environment.posthog.host,
    person_profiles: 'identified_only',
    // persistence: 'memory',
  });
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
